export enum buttonTypes {
  NEXT = 'Next',
  PREVIOUS = 'Prev',
}

export interface ButtonProps {
  type: buttonTypes;
  disabled: boolean;
  setPage: Function;
  width: number;
  extraSmallMobile: boolean;
}

export interface CustomPaginationProps {
  page: number;
  pageCount: number;
  pageSize: number;
  rowCount: number;
  setPage: (arg0: number) => void;
}
